import { moduleProviderFactory } from 'core/providers';
import { ReturnAddressList } from 'modules/return-address/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.return-address',
				pattern: '/return-address',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.return-address.list',
						pattern: '',
						component: ReturnAddressList,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/return-address/config.js